import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { WidgetStatus, WidgetMode } from 'constants/EmbedConfigurationConstants'
import OnlineToggle from 'components/shared/OnlineToggle'
import { patchOperations } from 'utils/PatchHelper'

class Toggle extends Component {
  static contextTypes = {
    app: PropTypes.object,
  }

  constructor(props) {
    super(props)

    this.onToggled = this.onToggled.bind(this)
  }

  onToggled(event) {
    const isChecked = event.target.checked
    const updatedWidgetStatus = isChecked ? WidgetStatus.ON : WidgetStatus.AWAY
    const updatedWidgetMode = WidgetMode.MANUAL

    this.update(updatedWidgetStatus, updatedWidgetMode)
  }

  update(updatedWidgetStatus, updatedWidgetMode) {
    const { widgetStatus, widgetMode } = this.props

    const initialObject = {
      widgetStatus,
      widgetMode,
    }
    const updatedObject = {
      widgetStatus: updatedWidgetStatus,
      widgetMode: updatedWidgetMode,
    }
    const changes = patchOperations(updatedObject, initialObject)
    this.props.updateStatus(changes)
  }

  render() {
    const { widgetStatus } = this.props
    const isChecked = widgetStatus === WidgetStatus.ON

    return (
      <div className="manualToggle">
        <OnlineToggle checked={isChecked} onChange={this.onToggled} />
      </div>
    )
  }
}

export default Toggle



// WEBPACK FOOTER //
// ./src/scripts/components/settings/ChatWidget/components/HoursAndTargeting/Toggle/index.js